var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErr500({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    style: {
      fill: "#EBEBEB"
    },
    width: 26,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.33,
    y: 389.21,
    style: {
      fill: "#EBEBEB"
    },
    width: 54.1,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 401.21,
    style: {
      fill: "#EBEBEB"
    },
    width: 26.32,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.67,
    y: 399.53,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.23,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    style: {
      fill: "#EBEBEB"
    },
    width: 30.29,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.23,
    y: 395.31,
    style: {
      fill: "#EBEBEB"
    },
    width: 54.56,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.01,337.8H43.92c-3.15,0-5.71-2.56-5.71-5.71V60.66c0-3.15,2.56-5.71,5.71-5.71h193.1    c3.15,0,5.71,2.56,5.71,5.71v271.43C242.72,335.24,240.16,337.8,237.01,337.8z M43.92,55.2c-3.01,0-5.46,2.45-5.46,5.46v271.43    c0,3.01,2.45,5.46,5.46,5.46h193.1c3.01,0,5.46-2.45,5.46-5.46V60.66c0-3.01-2.45-5.46-5.46-5.46H43.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8h-193.1c-3.15,0-5.71-2.56-5.71-5.71V60.66c0-3.15,2.56-5.71,5.71-5.71h193.1    c3.15,0,5.71,2.56,5.71,5.71v271.43C459.02,335.24,456.46,337.8,453.31,337.8z M260.21,55.2c-3.01,0-5.46,2.45-5.46,5.46v271.43    c0,3.01,2.45,5.46,5.46,5.46h193.1c3.01,0,5.46-2.45,5.46-5.46V60.66c0-3.01-2.45-5.46-5.46-5.46H260.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M382.19,149.61h-69.43c-3.75,3.75-5.85,5.85-9.59,9.59v213.61c3.75,3.75,5.85,5.85,9.59,9.59       h69.43c3.75-3.75,5.85-5.85,9.59-9.59V159.2C388.04,155.45,385.94,153.35,382.19,149.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "303.17,372.81 312.76,382.4 334.29,382.4 324.7,372.81      "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "303.17,159.2 312.76,149.61 334.29,149.61 324.7,159.2      "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M420.41,149.61h-86.12c-3.75,3.75-5.85,5.85-9.59,9.59v213.61c3.75,3.75,5.85,5.85,9.59,9.59      h86.12c3.75-3.75,5.85-5.85,9.59-9.59V159.2C426.25,155.45,424.15,153.35,420.41,149.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "335.52,377.92 329.18,371.59 329.18,160.42 335.52,154.09 419.19,154.09 425.52,160.42       425.52,371.59 419.19,377.92     "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 165.45,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.33,352.91c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,352.11,420.33,352.47,420.33,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,352.91c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,352.11,416.48,352.47,416.48,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.62,352.91c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,352.11,412.62,352.47,412.62,352.91z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 172.9,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 165.45,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 349.4048)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 185.74,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.33,332.62c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8s-0.36-0.8-0.8-0.8         C420.69,331.82,420.33,332.18,420.33,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,332.62c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8s-0.36-0.8-0.8-0.8         C416.83,331.82,416.48,332.18,416.48,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M412.62,332.62c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8s-0.36-0.8-0.8-0.8         C412.98,331.82,412.62,332.18,412.62,332.62z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 193.19,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 185.74,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 389.9832)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 206.03,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.33,312.34c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,311.53,420.33,311.89,420.33,312.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M416.48,312.34c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,311.53,416.48,311.89,416.48,312.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.62,312.34c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,311.53,412.62,311.89,412.62,312.34z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 213.48,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 206.03,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 430.5617)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 226.32,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.33,292.05c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,291.24,420.33,291.6,420.33,292.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,292.05c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,291.24,416.48,291.6,416.48,292.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.62,292.05c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,291.24,412.62,291.6,412.62,292.05z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 233.77,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 226.32,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 471.1401)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 246.61,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.33,271.76c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,270.95,420.33,271.31,420.33,271.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,271.76c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,270.95,416.48,271.31,416.48,271.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M412.62,271.76c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,270.95,412.62,271.31,412.62,271.76z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 254.06,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 246.61,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 511.7185)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 266.9,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.33,251.47c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,250.67,420.33,251.02,420.33,251.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,251.47c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,250.67,416.48,251.02,416.48,251.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.62,251.47c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,250.67,412.62,251.02,412.62,251.47z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 274.35,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 266.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 552.2969)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 287.19,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.33,231.18c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,230.38,420.33,230.74,420.33,231.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,231.18c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,230.38,416.48,230.74,416.48,231.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.62,231.18c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,230.38,412.62,230.74,412.62,231.18z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 294.64,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 287.19,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 592.8754)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 307.48,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.33,210.89c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,210.09,420.33,210.45,420.33,210.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M416.48,210.89c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,210.09,416.48,210.45,416.48,210.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M412.62,210.89c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,210.09,412.62,210.45,412.62,210.89z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 314.93,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 307.48,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 633.4538)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 327.77,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.33,190.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,189.8,420.33,190.16,420.33,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.48,190.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,189.8,416.48,190.16,416.48,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M412.62,190.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,189.8,412.62,190.16,412.62,190.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 335.22,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 327.77,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 674.0323)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 348.06,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M420.33,170.31c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C420.69,169.51,420.33,169.87,420.33,170.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M416.48,170.31c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C416.83,169.51,416.48,169.87,416.48,170.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M412.62,170.31c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C412.98,169.51,412.62,169.87,412.62,170.31z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.66,
    y: 355.51,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.18,
    y: 348.06,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 662.8418 714.6107)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M265.61,149.61h-69.43c-3.75,3.75-5.85,5.85-9.59,9.59v213.61c3.75,3.75,5.85,5.85,9.59,9.59       h69.43c3.75-3.75,5.85-5.85,9.59-9.59V159.2C271.45,155.45,269.35,153.35,265.61,149.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "186.58,372.81 196.18,382.4 217.71,382.4 208.12,372.81      "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "186.58,159.2 196.18,149.61 217.71,149.61 208.12,159.2      "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M303.82,149.61h-86.12c-3.75,3.75-5.85,5.85-9.59,9.59v213.61c3.75,3.75,5.85,5.85,9.59,9.59      h86.12c3.75-3.75,5.85-5.85,9.59-9.59V159.2C309.67,155.45,307.57,153.35,303.82,149.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "218.93,377.92 212.6,371.59 212.6,160.42 218.93,154.09 302.6,154.09 308.94,160.42       308.94,371.59 302.6,377.92     "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 165.45,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.75,170.31c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,170.75,303.75,170.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,170.31c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,171.11,299.89,170.75,299.89,170.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M296.03,170.31c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,171.11,296.03,170.75,296.03,170.31z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 172.9,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 165.45,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 349.4048)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 185.74,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.75,190.6c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,191.04,303.75,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,190.6c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,191.4,299.89,191.04,299.89,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.03,190.6c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,191.4,296.03,191.04,296.03,190.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 193.19,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 185.74,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 389.9832)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 206.03,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.75,210.89c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,211.33,303.75,210.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M299.89,210.89c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,211.69,299.89,211.33,299.89,210.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M296.03,210.89c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,211.69,296.03,211.33,296.03,210.89z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 213.48,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 206.03,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 430.5617)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 226.32,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.75,231.18c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,231.62,303.75,231.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,231.18c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,231.98,299.89,231.62,299.89,231.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M296.03,231.18c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,231.98,296.03,231.62,296.03,231.18z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 233.77,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 226.32,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 471.1401)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 246.61,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.75,251.47c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,251.91,303.75,251.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,251.47c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,252.27,299.89,251.91,299.89,251.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.03,251.47c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,252.27,296.03,251.91,296.03,251.47z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 254.06,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 246.61,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 511.7185)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 266.9,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.75,271.76c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,272.2,303.75,271.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,271.76c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,272.56,299.89,272.2,299.89,271.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M296.03,271.76c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,272.56,296.03,272.2,296.03,271.76z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 274.35,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 266.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 552.2969)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 287.19,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.75,292.05c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,292.49,303.75,292.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,292.05c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,292.85,299.89,292.49,299.89,292.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M296.03,292.05c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,292.85,296.03,292.49,296.03,292.05z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 294.64,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 287.19,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 592.8754)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 307.48,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.75,312.34c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,312.78,303.75,312.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M299.89,312.34c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,313.14,299.89,312.78,299.89,312.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.03,312.34c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,313.14,296.03,312.78,296.03,312.34z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 314.93,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 307.48,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 633.4538)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 327.77,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.75,332.62c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8s-0.36,0.8-0.8,0.8         S303.75,333.07,303.75,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.89,332.62c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8s-0.36,0.8-0.8,0.8         C300.25,333.43,299.89,333.07,299.89,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M296.03,332.62c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8s-0.36,0.8-0.8,0.8         C296.39,333.43,296.03,333.07,296.03,332.62z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 335.22,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 327.77,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 674.0323)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 348.06,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M303.75,352.91c0-0.44,0.36-0.8,0.8-0.8s0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         S303.75,353.36,303.75,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M299.89,352.91c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C300.25,353.72,299.89,353.36,299.89,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M296.03,352.91c0-0.44,0.36-0.8,0.8-0.8c0.44,0,0.8,0.36,0.8,0.8c0,0.44-0.36,0.8-0.8,0.8         C296.39,353.72,296.03,353.36,296.03,352.91z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 355.51,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 348.06,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 429.6722 714.6107)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M149.02,149.61H79.59c-3.75,3.75-5.85,5.85-9.59,9.59v213.61c3.75,3.75,5.85,5.85,9.59,9.59       h69.43c3.75-3.75,5.85-5.85,9.59-9.59V159.2C154.87,155.45,152.77,153.35,149.02,149.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "70,372.81 79.59,382.4 101.12,382.4 91.53,372.81      "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "70,159.2 79.59,149.61 101.12,149.61 91.53,159.2      "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M187.24,149.61h-86.11c-3.75,3.75-5.85,5.85-9.59,9.59v213.61c3.75,3.75,5.85,5.85,9.59,9.59      h86.11c3.75-3.75,5.85-5.85,9.59-9.59V159.2C193.09,155.45,190.99,153.35,187.24,149.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "102.35,377.92 96.01,371.59 96.01,160.42 102.35,154.09 186.02,154.09 192.35,160.42       192.35,371.59 186.02,377.92     "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 165.45,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.16,352.91c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,352.11,187.16,352.47,187.16,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,352.91c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,352.11,183.31,352.47,183.31,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.45,352.91c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,352.11,179.45,352.47,179.45,352.91z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 172.9,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 165.45,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 349.4048)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 185.74,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.16,332.62c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8s-0.36-0.8-0.8-0.8         C187.52,331.82,187.16,332.18,187.16,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,332.62c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8s-0.36-0.8-0.8-0.8         C183.66,331.82,183.31,332.18,183.31,332.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.45,332.62c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8s-0.36-0.8-0.8-0.8         C179.81,331.82,179.45,332.18,179.45,332.62z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 193.19,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 185.74,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 389.9832)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 206.03,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.16,312.34c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,311.53,187.16,311.89,187.16,312.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M183.31,312.34c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,311.53,183.31,311.89,183.31,312.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.45,312.34c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,311.53,179.45,311.89,179.45,312.34z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 213.48,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 206.03,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 430.5617)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 226.32,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.16,292.05c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,291.24,187.16,291.6,187.16,292.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,292.05c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,291.24,183.31,291.6,183.31,292.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.45,292.05c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,291.24,179.45,291.6,179.45,292.05z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 233.77,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 226.32,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 471.1401)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 246.61,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.16,271.76c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,270.95,187.16,271.31,187.16,271.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,271.76c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,270.95,183.31,271.31,183.31,271.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.45,271.76c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,270.95,179.45,271.31,179.45,271.76z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 254.06,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 246.61,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 511.7185)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 266.9,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.16,251.47c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,250.67,187.16,251.02,187.16,251.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,251.47c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,250.67,183.31,251.02,183.31,251.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.45,251.47c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,250.67,179.45,251.02,179.45,251.47z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 274.35,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 266.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 552.2969)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 287.19,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.16,231.18c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,230.38,187.16,230.74,187.16,231.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,231.18c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,230.38,183.31,230.74,183.31,231.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.45,231.18c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,230.38,179.45,230.74,179.45,231.18z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 294.64,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 287.19,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 592.8754)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 307.48,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.16,210.89c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,210.09,187.16,210.45,187.16,210.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M183.31,210.89c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,210.09,183.31,210.45,183.31,210.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.45,210.89c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,210.09,179.45,210.45,179.45,210.89z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 314.93,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 307.48,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 633.4538)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 327.77,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.16,190.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,189.8,187.16,190.16,187.16,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.31,190.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,189.8,183.31,190.16,183.31,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.45,190.6c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,189.8,179.45,190.16,179.45,190.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 335.22,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 327.77,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 674.0323)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 348.06,
    style: {
      fill: "#EBEBEB"
    },
    width: 91.86,
    height: 18.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M187.16,170.31c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C187.52,169.51,187.16,169.87,187.16,170.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M183.31,170.31c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C183.66,169.51,183.31,169.87,183.31,170.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M179.45,170.31c0,0.44,0.36,0.8,0.8,0.8c0.44,0,0.8-0.36,0.8-0.8c0-0.44-0.36-0.8-0.8-0.8         C179.81,169.51,179.45,169.87,179.45,170.31z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.49,
    y: 355.51,
    style: {
      fill: "#F5F5F5"
    },
    width: 91.86,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.01,
    y: 348.06,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 196.5026 714.6107)",
    style: {
      fill: "#E0E0E0"
    },
    width: 4.48,
    height: 18.5
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M182.83,95.18c-0.06-8.14-6.68-14.72-14.84-14.72c-1.96,0-3.84,0.39-5.55,1.08    c-2.91-5.96-9.04-10.07-16.12-10.07c-8.56,0-15.72,6.01-17.5,14.04c-8.05,0.52-14.43,7.21-14.43,15.4    c0,8.52,6.91,15.43,15.43,15.43h49.11c6.04,0,10.94-4.9,10.94-10.94C189.87,100.73,186.94,96.75,182.83,95.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M422.27,80.5c-0.08-10.77-8.84-19.48-19.63-19.48c-2.6,0-5.08,0.51-7.35,1.43    c-3.86-7.89-11.96-13.32-21.33-13.32c-11.33,0-20.8,7.95-23.16,18.57c-10.66,0.69-19.09,9.54-19.09,20.37    c0,11.28,9.14,20.42,20.42,20.42h64.98c7.99,0,14.48-6.48,14.48-14.48C431.59,87.84,427.72,82.58,422.27,80.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M297.46,150.69c-26.44-39.53-36.82-75.3-93.7-86.04c-38.39-7.25-85.35,1.32-108.67,29.73    C52.9,145.78,48.24,274.44,139.1,295.2c44.4,10.15,82.51-1.78,127.45,16.3c44.82,18.03,84.14,31.86,125.87-2.48    c26.72-22,40.58-63.08,15.68-91C378.01,184.25,327.17,195.11,297.46,150.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M297.46,150.69c-26.44-39.53-36.82-75.3-93.7-86.04    c-38.39-7.25-85.35,1.32-108.67,29.73C52.9,145.78,48.24,274.44,139.1,295.2c44.4,10.15,82.51-1.78,127.45,16.3    c44.82,18.03,84.14,31.86,125.87-2.48c26.72-22,40.58-63.08,15.68-91C378.01,184.25,327.17,195.11,297.46,150.69z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__369_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M86.52,401.47v-1.52h-8.96c-0.42,0-0.76,0.34-0.76,0.76l0,0c0,0.42,0.34,0.76,0.76,0.76H86.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M86.52,407.97v-1.52h-8.96c-0.42,0-0.76,0.34-0.76,0.76l0,0c0,0.42,0.34,0.76,0.76,0.76H86.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M83.3,396.24L83.3,396.24c-0.7,0-1.26,0.57-1.26,1.26v13.22c0,0.7,0.57,1.26,1.26,1.26l0,0       c0.7,0,1.26-0.57,1.26-1.26v-13.22C84.56,396.81,84,396.24,83.3,396.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M86.88,398.09H83.3v12.05h3.58c3.33,0,6.03-2.7,6.03-6.03l0,0       C92.91,400.79,90.21,398.09,86.88,398.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M115.12,412.36c-2.63,0-5.11-0.3-7.72-0.61l-4.4-0.53c-0.7,0.03-1.41,0.08-2.13,0.15       c-1.02,0.1-2.05,0.27-3.05,0.43c-1.89,0.3-3.84,0.61-5.81,0.54c-0.37-0.01-0.8-0.04-1.2-0.24c-0.5-0.25-0.82-0.72-0.81-1.21       c0.01-0.46,0.31-0.9,0.77-1.14c0.36-0.19,0.76-0.24,1.11-0.27c2.24-0.19,4.47,0.07,6.63,0.33l4.5,0.54       c1.82-0.08,3.58-0.04,5.29,0c2.18,0.05,4.44,0.1,6.8-0.09c2-0.16,3.43-0.84,3.5-1.13c-0.43-0.52-1.54-0.68-3.81-0.97       c-1.68-0.21-3.82-0.27-6.09-0.33c-1.79-0.05-3.64-0.1-5.53-0.22c-3.77-0.25-8.63-0.85-12.77-3.27       c-0.21-0.12-0.28-0.39-0.16-0.6c0.12-0.21,0.39-0.28,0.6-0.16c3.97,2.33,8.71,2.91,12.38,3.15c1.87,0.13,3.71,0.17,5.49,0.22       c2.29,0.06,4.45,0.12,6.18,0.34c1.33,0.17,2.27,0.29,2.95,0.48c-0.04-0.05-0.08-0.1-0.12-0.15c-0.33-0.42-0.66-0.86-0.96-1.32       c-0.37-0.58-0.79-1.26-0.96-2.04c-0.2-0.89-0.01-1.78,0.5-2.37c0.63-0.74,1.66-0.92,2.37-1c2.11-0.22,4.21,0.09,6.24,0.39       c0.24,0.04,0.4,0.26,0.37,0.5c-0.04,0.24-0.25,0.41-0.5,0.37c-1.98-0.29-4.02-0.59-6.02-0.38c-0.56,0.06-1.36,0.2-1.8,0.7       c-0.33,0.38-0.44,0.99-0.31,1.62c0.14,0.64,0.51,1.24,0.84,1.75c0.28,0.43,0.61,0.86,0.92,1.26c0.2,0.26,0.41,0.53,0.6,0.8       l0.1,0.14c0.45,0.61,1.06,1.44,0.93,2.33c-0.28,1.92-2.99,1.97-4.3,2C115.57,412.36,115.34,412.36,115.12,412.36z        M111.04,411.28c1.56,0.15,3.1,0.23,4.68,0.2c1.12-0.02,3.33-0.06,3.5-1.25c0.02-0.13,0-0.26-0.03-0.4       c-0.75,0.78-2.71,1.21-4,1.31C113.77,411.25,112.39,411.28,111.04,411.28z M93.5,410.29c-0.51,0-1.02,0.02-1.53,0.06       c-0.27,0.02-0.56,0.06-0.78,0.17c-0.18,0.09-0.3,0.25-0.3,0.39c0,0.15,0.13,0.32,0.32,0.41c0.24,0.12,0.55,0.14,0.84,0.15       c1.88,0.07,3.79-0.24,5.64-0.53c0.42-0.07,0.85-0.13,1.27-0.2l-0.53-0.06C96.81,410.49,95.15,410.29,93.5,410.29z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.11,171.01h-89.79c-3.91,3.91-6.09,6.09-10,10v222.72c3.91,3.91,6.09,6.09,10,10h89.79c3.91-3.91,6.09-6.09,10-10     V181.01C226.21,177.11,224.02,174.92,220.11,171.01z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "104.16,190.4 102.14,193.15 97,185.82 100.85,200.2 102.88,197.45 108.01,204.79    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "181.06,142.2 178.02,143.76 176.69,134.91 173.73,149.5 176.77,147.94 178.1,156.8    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "206.65,146.2 202.03,145.12 208.58,134.55 192.33,147.35 196.95,148.42 190.4,158.99         "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#263238"
    },
    points: "120.32,403.74 130.32,413.74 170.17,413.74 160.17,403.74    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#263238"
    },
    points: "120.32,181.01 130.32,171.01 170.17,171.01 160.17,181.01    "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M259.96,171.01h-89.79c-3.91,3.91-6.09,6.09-10,10v222.72c3.91,3.91,6.09,6.09,10,10h89.79    c3.91-3.91,6.09-6.09,10-10V181.01C266.05,177.11,263.86,174.92,259.96,171.01z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#407BFF"
    },
    points: "171.44,409.07 164.84,402.46 164.84,182.29 171.44,175.68 258.69,175.68     265.29,182.29 265.29,402.46 258.69,409.07   "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 187.53,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M259.88,192.6c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84c0,0.46-0.37,0.84-0.84,0.84       S259.88,193.06,259.88,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.86,192.6c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84c0,0.46-0.37,0.84-0.84,0.84       S255.86,193.06,255.86,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M251.83,192.6c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84c0,0.46-0.37,0.84-0.84,0.84       S251.83,193.06,251.83,192.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 195.3,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 187.53,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 394.3561)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 208.69,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 260.72,
    cy: 213.75,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.69,
    cy: 213.75,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 252.67,
    cy: 213.75,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 216.46,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 208.69,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 436.6659)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 229.84,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 260.72,
    cy: 234.91,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 256.69,
    cy: 234.91,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 252.67,
    cy: 234.91,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 237.61,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 229.84,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 478.9757)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 251,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 260.72,
    cy: 256.06,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.69,
    cy: 256.06,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 252.67,
    cy: 256.06,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 258.77,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 251,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 521.2854)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 272.15,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.88,277.22c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84s-0.37,0.84-0.84,0.84       S259.88,277.68,259.88,277.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.86,277.22c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84s-0.37,0.84-0.84,0.84       S255.86,277.68,255.86,277.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.83,277.22c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84s-0.37,0.84-0.84,0.84       S251.83,277.68,251.83,277.22z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 279.92,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 272.15,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 563.5951)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 293.31,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M259.88,298.37c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84c0,0.46-0.37,0.84-0.84,0.84       S259.88,298.84,259.88,298.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M255.86,298.37c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84c0,0.46-0.37,0.84-0.84,0.84       S255.86,298.84,255.86,298.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M251.83,298.37c0-0.46,0.37-0.84,0.84-0.84s0.84,0.37,0.84,0.84c0,0.46-0.37,0.84-0.84,0.84       S251.83,298.84,251.83,298.37z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 301.08,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 293.31,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 605.9049)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 314.46,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 260.72,
    cy: 319.53,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.69,
    cy: 319.53,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 252.67,
    cy: 319.53,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 322.23,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 314.46,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 648.2147)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 335.62,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 260.72,
    cy: 340.68,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 256.69,
    cy: 340.68,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 252.67,
    cy: 340.68,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 343.39,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 335.62,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 690.5245)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 356.77,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 260.72,
    cy: 361.84,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.69,
    cy: 361.84,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 252.67,
    cy: 361.84,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 364.54,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 356.77,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 732.8343)",
    width: 4.67,
    height: 19.29
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 377.93,
    style: {
      fill: "#263238"
    },
    width: 95.78,
    height: 19.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 260.72,
    cy: 382.99,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 256.69,
    cy: 382.99,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 252.67,
    cy: 382.99,
    r: 0.84
  })), /*#__PURE__*/React.createElement("rect", {
    x: 169.51,
    y: 385.7,
    style: {
      fill: "#407BFF"
    },
    width: 95.78,
    height: 3.75
  }), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 377.93,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 334.3482 775.1439)",
    width: 4.67,
    height: 19.29
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#407BFF"
    },
    points: "171.44,409.07 164.84,402.46 164.84,182.29 171.44,175.68 223.12,175.68     229.72,182.29 229.72,402.46 223.12,409.07   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "223.12,409.07 229.72,402.46 229.72,182.29 223.12,175.68 225.71,175.68 231.38,181.35     231.38,403.4 225.71,409.07 223.12,409.07   "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M358.18,179.71c2.18,4.26,4.11,8.49,5.88,12.91c0.89,2.2,1.72,4.45,2.48,6.75    c0.78,2.3,1.47,4.66,1.99,7.32l0.1,0.5l0.05,0.27l0.05,0.37c0.03,0.25,0.07,0.51,0.08,0.74l0.03,0.66    c0.02,0.87-0.03,1.61-0.11,2.34c-0.17,1.43-0.43,2.71-0.73,3.95c-0.58,2.48-1.38,4.77-2.2,7.03c-1.69,4.51-3.65,8.76-5.94,12.96    c-0.72,1.33-2.39,1.82-3.72,1.1c-1.11-0.61-1.64-1.87-1.36-3.04l0.02-0.06c1.05-4.42,2.11-8.9,3-13.26    c0.46-2.18,0.83-4.36,1.09-6.42c0.12-1.03,0.2-2.04,0.2-2.91c-0.01-0.43-0.02-0.84-0.06-1.12l-0.03-0.21l-0.04-0.12l-0.06-0.21    l-0.1-0.35c-0.54-1.83-1.3-3.87-2.13-5.9c-0.84-2.03-1.72-4.07-2.64-6.12c-1.84-4.08-3.78-8.23-5.68-12.26l-0.03-0.06    c-1.29-2.75-0.11-6.03,2.64-7.32C353.63,175.97,356.83,177.09,358.18,179.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M353.33,234.89l3.42-5.04l3.38-1.02c1.57,1.9,1.11,4.83,0.65,6.51l0,0l-0.98,6.26    c-0.18,1.18-1.11,2.08-2.3,2.25l-2.23,0.31c-1.65,0.23-3.16-0.97-3.3-2.64l-0.09-1.09C351.71,238.48,352.22,236.52,353.33,234.89z    "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.76,248.4c0.84-0.99,1.22-2.21,1.18-3.41l16.82-7.81c0.04,0.04,0.08,0.08,0.13,0.11     c2.13,1.79,5.31,1.52,7.11-0.61c0.38-0.45,0.67-0.96,0.87-1.48l-3.66,0.49c-0.97,0.13-1.85-0.57-1.94-1.55l-0.11-1.26     c-0.08-0.97,0.67-1.82,1.64-1.86l3.69-0.13c-0.28-0.49-0.65-0.93-1.11-1.31c-2.13-1.79-5.31-1.52-7.11,0.61     c-0.84,0.99-1.22,2.21-1.18,3.41l-16.82,7.81c-0.04-0.04-0.08-0.08-0.13-0.11c-2.13-1.79-5.31-1.52-7.11,0.61     c-0.38,0.45-0.67,0.96-0.87,1.48l3.66-0.49c0.97-0.13,1.85,0.58,1.94,1.55l0.11,1.26c0.08,0.97-0.67,1.82-1.64,1.86l-3.69,0.13     c0.28,0.49,0.65,0.93,1.11,1.31C342.79,250.8,345.97,250.53,347.76,248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M348.61,242.97L348.61,242.97c-0.24-0.51-0.01-1.11,0.49-1.35l13.46-6.25     c0.51-0.24,1.11-0.02,1.35,0.49l0,0c0.24,0.51,0.01,1.11-0.49,1.35l-13.46,6.25C349.45,243.7,348.85,243.48,348.61,242.97z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M346.33,169.28c6.03,1.33,8.97,4.41,14.79,14.1c-3.3,4.89-11.37,9.12-11.37,9.12l-3.49-4.02    C341.88,180.35,346.33,169.28,346.33,169.28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M344.34,180.35c0.03,2.71,0.54,5.57,1.92,8.13l3.49,4.02c0,0,1.27-0.67,3.02-1.78    C349.91,185.02,347.68,182.15,344.34,180.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M318.55,178.58l-0.11,0.63l-0.1,0.48l-0.21,0.89c-0.16,0.58-0.34,1.13-0.53,1.68    c-0.39,1.09-0.85,2.14-1.37,3.17c-1.06,2.04-2.41,3.96-4.03,5.64c-1.61,1.69-3.49,3.14-5.5,4.28c-2.01,1.14-4.16,1.95-6.31,2.49    l-0.35,0.09c-2.59,0.65-5.22-0.92-5.88-3.52c-0.06-0.23-0.1-0.49-0.12-0.73c-0.21-2.2-0.01-4.19,0.36-6.03    c0.37-1.84,0.88-3.56,1.47-5.2c1.19-3.27,2.71-6.25,4.33-9.1c1.65-2.84,3.43-5.55,5.32-8.16c1.93-2.6,3.87-5.1,6.07-7.54    c1.01-1.12,2.74-1.21,3.86-0.2c0.98,0.88,1.17,2.31,0.53,3.4l-0.04,0.07c-1.51,2.59-3.05,5.29-4.43,8    c-1.41,2.7-2.75,5.42-3.92,8.16c-1.2,2.73-2.21,5.49-2.94,8.18c-0.71,2.65-1.08,5.37-0.74,7.22l-6.35-4.15    c1.35-0.52,2.57-1.18,3.69-1.93c1.1-0.78,2.08-1.67,2.93-2.67c0.84-1.01,1.59-2.13,2.2-3.34c0.31-0.6,0.59-1.23,0.81-1.86    c0.12-0.31,0.21-0.63,0.31-0.93l0.13-0.44l0.05-0.19c0.01-0.03,0.03-0.16,0.02-0.04c0.46-3,3.27-5.06,6.27-4.6    C316.96,172.77,319.02,175.58,318.55,178.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M321.09,177.83c0.63-3.76-2.02-8.28-2.02-8.28c-5.96,0.3-11.71,1.75-17.24,13.05    c1.33,6.3,9.68,10.74,9.68,10.74l5.9-7.64C317.4,185.71,320.46,181.6,321.09,177.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M313.23,154.88l1.66-1.8c0.72-0.78,1.61-1.37,2.61-1.72l1.58-0.56c1.78-0.64,3.7,0.46,4.05,2.32    l0.39,2.07c0.3,1.55-0.64,3.08-2.16,3.52l-2.43,0.71c0,0-2.9,4.85-8.54,2.65C310.39,159.43,311.4,156.85,313.23,154.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M356.83,398.09h-8.32c0,0,0.41,6.1,0.38,9.71l7.33,0.88C355.59,404.67,356.83,398.09,356.83,398.09    z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M320.17,226.93c0,0,14.93,63.27,19.59,88.98c4.89,27.01,8.22,81.17,8.21,83.15    c2.68-0.52,7.04-0.65,9.15,0c0,0,10.28-63.69,0.97-87.34c-3.53-44.84,1.04-70.21-7.96-84.79L320.17,226.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M339.18,246.55c-2.44-9.97-10.72-9.01-16.11-7.18c3.36,14.45,8.93,38.78,13,58.08    C341.85,283.59,342.48,260.01,339.18,246.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M303.84,397.04c-0.75,9.67-8.6,20.07-8.6,20.07l12.11-3.1l5.1-7.58c0.2-2.98,0.21-5.42,1.13-8.55    L303.84,397.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M308.02,226.93c0,0,2.11,67.31,1.56,86.98c-0.77,27.27-6.49,85.15-6.49,85.15    c4.34-0.44,8.09-0.58,10.49,0c0,0,17.97-46.85,15.89-84.89c4.5-35.25,19.67-67.63,10.29-87.24L308.02,226.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M340.07,150.96c-1.18,5.1-2.5,14.45,0.95,17.86c0,0-3.85,6.75-12.66,10.39    c-6.68-4.28-3.2-10.39-3.2-10.39c5.74-1.36,5.74-5.58,4.89-9.55L340.07,150.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M341.07,163.57c0,0-11.6-1.58-17.3,3.15c-0.13,1.97-1.38,3.16-1.38,3.16    c6.23,1.37,12.54,1.66,18.93,0.93C342.82,168.22,341.07,163.57,341.07,163.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M309.22,180.8c0.62,16.01-2.91,40.32-1.2,46.13c17.16,1.74,30.57,1.44,42.11,0    c2.02-6.33-2.77-25.13,2.71-47.5c1.22-4.97-2.12-9.73-7.15-10.25c-1.48-0.15-3.06-0.28-4.68-0.36c-5.87-0.28-10.68-0.47-15.86,0    c-2.02,0.18-4.12,0.45-6.09,0.74C313.49,170.37,309.01,175.2,309.22,180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M321.24,142.38c-0.07,0.7-0.48,1.24-0.93,1.21c-0.45-0.03-0.76-0.61-0.7-1.31    c0.07-0.7,0.48-1.24,0.93-1.21C320.99,141.1,321.3,141.69,321.24,142.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M320.74,141.13l-1.61-0.58C319.13,140.54,319.85,141.9,320.74,141.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M320.35,137.82c-0.1-0.02-0.18-0.08-0.24-0.18c-0.11-0.19-0.05-0.44,0.14-0.57    c1.93-1.22,3.62-0.47,3.69-0.44c0.2,0.09,0.28,0.33,0.19,0.54c-0.1,0.21-0.34,0.3-0.54,0.21c-0.07-0.03-1.39-0.59-2.92,0.38    C320.56,137.83,320.45,137.84,320.35,137.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED893E"
    },
    d: "M321.1,144.3c0,0-1.45,2.92-2.87,4.29c0.83,0.91,2.41,0.62,2.41,0.62L321.1,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M344.73,140.95c-1.32,8.51-1.7,12.13-6.38,16.25c-7.04,6.2-17.07,3.06-18.29-5.59    c-1.09-7.78,1.25-20.38,9.84-23.28C338.37,125.49,346.05,132.44,344.73,140.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M323.52,131.38c-1.71,3.37,1.66,9.62,3.93,12.18c-4.03,4.33-8.05,11.8-2.73,16.27    c4.85,4.08,30.92,4.04,25.85-4.74c4.47-5.5-2.97-6.28,0.58-16.96c2.59-7.77-2.29-9.93-6.66-9.18    C339.51,122.65,327.07,124.37,323.52,131.38z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M325.43,134.91c0,0,8.05,6.6,17.33,7.68c4.97,0.58,7.5,0.51,7.73-0.25     c0.23-0.76,0.66-3.33,0.66-3.33L325.43,134.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M318.59,133.18c2.44,1.93,20.88,7.2,33.31,6.04c0.12-0.74-0.28-0.83-0.28-0.83     s2.86-9.59-3.71-13.19c-3.1-5.07-12.46-4.76-16.6-3.33l-0.59,0.74c0,0-8.11,1.89-8.23,8.62     C319.29,131.59,315.9,131.06,318.59,133.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M330.72,122.61l0.59-0.74c0,0,6.5-0.75,12.04,3.96C340.2,124.01,335,122.25,330.72,122.61z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB573"
    },
    d: "M326.22,140.86c-1.77-0.24-3.45,2.34-4.05,4.18c-0.67,2.05,0.06,3.96,1.89,3.3    c1.22-0.44,2.57-1.53,3.42-3.14C328.45,143.35,327.96,141.09,326.22,140.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M351.41,402.2c5.1-0.9,5.01,1.73,5.34,4.57c0.19,1.63,0.03,3.46-0.84,5    c-1.8,3.16-0.26,7.84-5.99,7.84c-5.73,0-6.25-1.33-4.7-4.16c1.55-2.83,2.33-5.82,3.02-9.09    C348.59,404.73,349.14,402.6,351.41,402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M356.42,408.25c0,3.43,0.06,11.37,0.06,11.37l-0.91-0.03c0,0-0.78-8.45-1.28-10.73L356.42,408.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M313.1,403.33c0.4,0.9,0.52,1.89,0.46,2.88c-0.21,3.63-0.99,13.24-0.99,13.24l-0.83,0.01    c0,0,0.24-6.47-0.08-8.86c-0.32-2.38-1.5,1.83-3.15,4.22c-1.66,2.39-4.82,4.56-10.22,4.73c-6.32,0.2-8.87-0.07-6.97-1.65    c1.9-1.58,6.13-2.62,6.13-2.62s4.83-1.79,7.95-7.15c2.02-3.48,4.99-5.06,6.61-5.88C312.52,402.33,312.86,402.78,313.1,403.33z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x35_00_Internal_Server_Error"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M96.73,69.5h12.98v4.36h-8.79l-0.47,2.95c0.61-0.29,1.21-0.5,1.81-0.64      c0.6-0.14,1.18-0.21,1.77-0.21c1.97,0,3.57,0.6,4.79,1.79c1.23,1.19,1.84,2.69,1.84,4.5c0,1.27-0.32,2.49-0.95,3.67      c-0.63,1.17-1.53,2.07-2.68,2.68c-1.16,0.62-2.64,0.93-4.45,0.93c-1.3,0-2.41-0.12-3.34-0.37s-1.71-0.61-2.36-1.1      c-0.65-0.49-1.17-1.04-1.58-1.66c-0.4-0.62-0.74-1.39-1.01-2.31l5.53-0.6c0.13,0.89,0.45,1.56,0.94,2.02      c0.49,0.46,1.08,0.69,1.76,0.69c0.76,0,1.39-0.29,1.89-0.87c0.5-0.58,0.75-1.44,0.75-2.58c0-1.17-0.25-2.03-0.75-2.58      c-0.5-0.55-1.17-0.82-2-0.82c-0.53,0-1.04,0.13-1.53,0.39c-0.37,0.19-0.77,0.53-1.21,1.02l-4.66-0.67L96.73,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M112.85,79.25c0-3.74,0.67-6.36,2.02-7.85c1.35-1.49,3.4-2.24,6.16-2.24      c1.32,0,2.41,0.16,3.26,0.49c0.85,0.33,1.54,0.75,2.08,1.28c0.54,0.52,0.96,1.07,1.27,1.65c0.31,0.58,0.56,1.25,0.75,2.02      c0.37,1.47,0.55,3,0.55,4.59c0,3.57-0.6,6.18-1.81,7.84c-1.21,1.66-3.29,2.48-6.24,2.48c-1.66,0-2.99-0.26-4.01-0.79      c-1.02-0.53-1.86-1.3-2.51-2.32c-0.47-0.72-0.84-1.72-1.11-2.97C112.98,82.17,112.85,80.78,112.85,79.25z M118.27,79.27      c0,2.51,0.22,4.22,0.66,5.13c0.44,0.92,1.09,1.38,1.93,1.38c0.55,0,1.04-0.19,1.44-0.58c0.41-0.39,0.71-1,0.9-1.85      c0.19-0.84,0.29-2.15,0.29-3.93c0-2.61-0.22-4.37-0.66-5.27c-0.44-0.9-1.11-1.35-1.99-1.35c-0.9,0-1.56,0.46-1.96,1.38      C118.47,75.09,118.27,76.79,118.27,79.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M131.19,79.25c0-3.74,0.67-6.36,2.02-7.85c1.35-1.49,3.4-2.24,6.16-2.24      c1.32,0,2.41,0.16,3.26,0.49c0.85,0.33,1.54,0.75,2.08,1.28c0.54,0.52,0.96,1.07,1.27,1.65c0.31,0.58,0.56,1.25,0.75,2.02      c0.37,1.47,0.55,3,0.55,4.59c0,3.57-0.6,6.18-1.81,7.84c-1.21,1.66-3.29,2.48-6.24,2.48c-1.66,0-2.99-0.26-4.01-0.79      c-1.02-0.53-1.86-1.3-2.51-2.32c-0.47-0.72-0.84-1.72-1.11-2.97C131.32,82.17,131.19,80.78,131.19,79.25z M136.61,79.27      c0,2.51,0.22,4.22,0.66,5.13c0.44,0.92,1.08,1.38,1.93,1.38c0.55,0,1.04-0.19,1.44-0.58c0.41-0.39,0.71-1,0.9-1.85      c0.19-0.84,0.29-2.15,0.29-3.93c0-2.61-0.22-4.37-0.66-5.27c-0.44-0.9-1.11-1.35-1.99-1.35c-0.9,0-1.56,0.46-1.96,1.38      C136.81,75.09,136.61,76.79,136.61,79.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.13,89.18V69.5h2.6v19.68H160.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M167.02,89.18V74.92h2.17v2.03c1.05-1.57,2.56-2.35,4.54-2.35c0.86,0,1.65,0.15,2.37,0.46      c0.72,0.31,1.26,0.71,1.62,1.21c0.36,0.5,0.61,1.1,0.75,1.79c0.09,0.45,0.13,1.23,0.13,2.35v8.77h-2.42V80.5      c0-0.98-0.09-1.72-0.28-2.21c-0.19-0.49-0.52-0.88-1-1.17c-0.48-0.29-1.04-0.44-1.68-0.44c-1.03,0-1.92,0.33-2.66,0.98      c-0.75,0.65-1.12,1.89-1.12,3.72v7.79H167.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M187.58,87.01l0.35,2.13c-0.68,0.14-1.29,0.21-1.83,0.21c-0.88,0-1.56-0.14-2.04-0.42      c-0.48-0.28-0.82-0.64-1.02-1.09c-0.2-0.45-0.3-1.4-0.3-2.85v-8.2h-1.77v-1.88h1.77v-3.53l2.4-1.45v4.98h2.43v1.88h-2.43v8.34      c0,0.69,0.04,1.13,0.13,1.33c0.08,0.2,0.22,0.35,0.42,0.47c0.19,0.12,0.47,0.17,0.83,0.17      C186.79,87.11,187.14,87.08,187.58,87.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M199.71,84.58l2.5,0.31c-0.39,1.46-1.12,2.59-2.19,3.4c-1.07,0.81-2.43,1.21-4.08,1.21      c-2.09,0-3.74-0.64-4.96-1.93c-1.22-1.28-1.83-3.08-1.83-5.4c0-2.4,0.62-4.26,1.85-5.58c1.23-1.33,2.84-1.99,4.81-1.99      c1.91,0,3.46,0.65,4.67,1.95c1.21,1.3,1.81,3.12,1.81,5.48c0,0.14,0,0.36-0.01,0.64h-10.63c0.09,1.57,0.53,2.77,1.33,3.6      c0.8,0.83,1.79,1.25,2.98,1.25c0.89,0,1.64-0.23,2.27-0.7C198.84,86.35,199.34,85.6,199.71,84.58z M191.77,80.68h7.96      c-0.11-1.2-0.41-2.1-0.91-2.7c-0.77-0.93-1.77-1.4-2.99-1.4c-1.11,0-2.04,0.37-2.8,1.11C192.27,78.44,191.85,79.43,191.77,80.68      z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M205.21,89.18V74.92h2.17v2.16c0.55-1.01,1.07-1.68,1.54-2c0.47-0.32,0.99-0.48,1.55-0.48      c0.81,0,1.64,0.26,2.48,0.78l-0.83,2.24c-0.59-0.35-1.18-0.52-1.77-0.52c-0.53,0-1,0.16-1.42,0.48      c-0.42,0.32-0.72,0.76-0.9,1.32c-0.27,0.86-0.4,1.8-0.4,2.82v7.46H205.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M214.39,89.18V74.92h2.17v2.03c1.05-1.57,2.56-2.35,4.54-2.35c0.86,0,1.65,0.15,2.37,0.46      c0.72,0.31,1.26,0.71,1.62,1.21c0.36,0.5,0.61,1.1,0.75,1.79c0.09,0.45,0.13,1.23,0.13,2.35v8.77h-2.42V80.5      c0-0.98-0.09-1.72-0.28-2.21c-0.19-0.49-0.52-0.88-1-1.17c-0.48-0.29-1.04-0.44-1.68-0.44c-1.03,0-1.92,0.33-2.66,0.98      c-0.75,0.65-1.12,1.89-1.12,3.72v7.79H214.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M238.99,87.42c-0.89,0.76-1.76,1.3-2.58,1.61c-0.83,0.31-1.72,0.47-2.66,0.47      c-1.57,0-2.77-0.38-3.61-1.15c-0.84-0.77-1.26-1.74-1.26-2.93c0-0.7,0.16-1.34,0.48-1.91c0.32-0.58,0.73-1.04,1.25-1.39      c0.51-0.35,1.09-0.61,1.74-0.79c0.47-0.13,1.19-0.25,2.15-0.36c1.95-0.23,3.39-0.51,4.31-0.83c0.01-0.33,0.01-0.54,0.01-0.63      c0-0.98-0.23-1.68-0.69-2.08c-0.62-0.55-1.53-0.82-2.75-0.82c-1.14,0-1.98,0.2-2.52,0.6c-0.54,0.4-0.94,1.1-1.2,2.11l-2.36-0.32      c0.21-1.01,0.57-1.83,1.06-2.45c0.49-0.62,1.2-1.1,2.13-1.44c0.93-0.34,2.01-0.5,3.24-0.5c1.22,0,2.21,0.14,2.97,0.43      c0.76,0.29,1.32,0.65,1.68,1.08c0.36,0.43,0.61,0.98,0.75,1.64c0.08,0.41,0.12,1.15,0.12,2.23v3.22c0,2.25,0.05,3.67,0.15,4.26      c0.1,0.6,0.31,1.17,0.61,1.71h-2.52C239.22,88.67,239.06,88.09,238.99,87.42z M238.78,82.02c-0.88,0.36-2.19,0.66-3.95,0.91      c-0.99,0.14-1.7,0.3-2.11,0.48c-0.41,0.18-0.73,0.44-0.95,0.79c-0.22,0.34-0.34,0.73-0.34,1.15c0,0.64,0.24,1.18,0.73,1.61      c0.49,0.43,1.2,0.64,2.14,0.64c0.93,0,1.76-0.2,2.48-0.61c0.73-0.41,1.26-0.96,1.6-1.67c0.26-0.55,0.39-1.35,0.39-2.42V82.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M244.92,89.18V69.5h2.42v19.68H244.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M257.75,84.92l2.39-0.38c0.13,0.96,0.51,1.69,1.12,2.2c0.61,0.51,1.47,0.76,2.57,0.76      c1.11,0,1.93-0.23,2.47-0.68c0.54-0.45,0.81-0.98,0.81-1.59c0-0.55-0.24-0.98-0.71-1.29c-0.33-0.21-1.15-0.49-2.47-0.82      c-1.77-0.45-3-0.83-3.68-1.16c-0.68-0.33-1.2-0.78-1.56-1.36c-0.35-0.58-0.53-1.21-0.53-1.91c0-0.64,0.15-1.22,0.44-1.77      c0.29-0.54,0.69-0.99,1.19-1.35c0.38-0.28,0.89-0.51,1.54-0.7c0.65-0.19,1.34-0.29,2.09-0.29c1.12,0,2.1,0.16,2.95,0.48      c0.85,0.32,1.47,0.76,1.87,1.31c0.4,0.55,0.68,1.29,0.83,2.21l-2.36,0.32c-0.11-0.73-0.42-1.31-0.93-1.72      c-0.51-0.41-1.24-0.62-2.18-0.62c-1.11,0-1.9,0.18-2.38,0.55c-0.47,0.37-0.71,0.8-0.71,1.29c0,0.31,0.1,0.59,0.3,0.85      c0.2,0.26,0.51,0.47,0.93,0.64c0.24,0.09,0.95,0.29,2.13,0.62c1.71,0.46,2.9,0.83,3.58,1.12c0.68,0.29,1.21,0.71,1.59,1.27      c0.38,0.55,0.58,1.24,0.58,2.07c0,0.81-0.23,1.56-0.7,2.28c-0.47,0.71-1.15,1.26-2.03,1.65c-0.89,0.39-1.89,0.58-3.01,0.58      c-1.85,0-3.26-0.38-4.24-1.15C258.64,87.57,258.02,86.43,257.75,84.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M282.23,84.58l2.5,0.31c-0.39,1.46-1.12,2.59-2.19,3.4c-1.07,0.81-2.43,1.21-4.08,1.21      c-2.09,0-3.74-0.64-4.96-1.93c-1.22-1.28-1.83-3.08-1.83-5.4c0-2.4,0.62-4.26,1.85-5.58c1.23-1.33,2.84-1.99,4.81-1.99      c1.91,0,3.46,0.65,4.67,1.95c1.21,1.3,1.81,3.12,1.81,5.48c0,0.14,0,0.36-0.01,0.64h-10.63c0.09,1.57,0.53,2.77,1.33,3.6      c0.8,0.83,1.79,1.25,2.98,1.25c0.89,0,1.64-0.23,2.27-0.7C281.36,86.35,281.86,85.6,282.23,84.58z M274.29,80.68h7.96      c-0.11-1.2-0.41-2.1-0.91-2.7c-0.77-0.93-1.77-1.4-2.99-1.4c-1.11,0-2.04,0.37-2.8,1.11C274.79,78.44,274.37,79.43,274.29,80.68      z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M287.73,89.18V74.92h2.17v2.16c0.55-1.01,1.07-1.68,1.54-2c0.47-0.32,0.99-0.48,1.55-0.48      c0.81,0,1.64,0.26,2.48,0.78l-0.83,2.24c-0.59-0.35-1.18-0.52-1.77-0.52c-0.53,0-1,0.16-1.42,0.48      c-0.42,0.32-0.72,0.76-0.9,1.32c-0.27,0.86-0.4,1.8-0.4,2.82v7.46H287.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M300.87,89.18l-5.42-14.26H298l3.06,8.54c0.33,0.92,0.64,1.88,0.91,2.87      c0.21-0.75,0.51-1.66,0.9-2.71l3.17-8.7h2.48l-5.4,14.26H300.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M320.42,84.58l2.5,0.31c-0.39,1.46-1.12,2.59-2.19,3.4c-1.07,0.81-2.43,1.21-4.08,1.21      c-2.09,0-3.74-0.64-4.96-1.93c-1.22-1.28-1.83-3.08-1.83-5.4c0-2.4,0.62-4.26,1.85-5.58c1.23-1.33,2.84-1.99,4.81-1.99      c1.91,0,3.46,0.65,4.67,1.95c1.21,1.3,1.81,3.12,1.81,5.48c0,0.14,0,0.36-0.01,0.64h-10.63c0.09,1.57,0.53,2.77,1.33,3.6      c0.8,0.83,1.79,1.25,2.98,1.25c0.89,0,1.64-0.23,2.27-0.7C319.55,86.35,320.05,85.6,320.42,84.58z M312.48,80.68h7.96      c-0.11-1.2-0.41-2.1-0.91-2.7c-0.77-0.93-1.77-1.4-2.99-1.4c-1.11,0-2.04,0.37-2.8,1.11C312.98,78.44,312.57,79.43,312.48,80.68      z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M325.92,89.18V74.92h2.17v2.16c0.55-1.01,1.07-1.68,1.54-2c0.47-0.32,0.99-0.48,1.55-0.48      c0.81,0,1.64,0.26,2.48,0.78l-0.83,2.24c-0.59-0.35-1.18-0.52-1.77-0.52c-0.53,0-1,0.16-1.42,0.48      c-0.42,0.32-0.72,0.76-0.9,1.32c-0.27,0.86-0.4,1.8-0.4,2.82v7.46H325.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M352.5,84.58l2.5,0.31c-0.39,1.46-1.12,2.59-2.19,3.4c-1.07,0.81-2.43,1.21-4.08,1.21      c-2.09,0-3.74-0.64-4.96-1.93c-1.22-1.28-1.83-3.08-1.83-5.4c0-2.4,0.62-4.26,1.85-5.58c1.23-1.33,2.84-1.99,4.81-1.99      c1.91,0,3.46,0.65,4.67,1.95c1.21,1.3,1.81,3.12,1.81,5.48c0,0.14,0,0.36-0.01,0.64h-10.63c0.09,1.57,0.53,2.77,1.33,3.6      c0.8,0.83,1.79,1.25,2.98,1.25c0.89,0,1.64-0.23,2.27-0.7C351.64,86.35,352.14,85.6,352.5,84.58z M344.57,80.68h7.96      c-0.11-1.2-0.41-2.1-0.91-2.7c-0.77-0.93-1.77-1.4-2.99-1.4c-1.11,0-2.04,0.37-2.8,1.11C345.07,78.44,344.65,79.43,344.57,80.68      z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M358.01,89.18V74.92h2.17v2.16c0.55-1.01,1.07-1.68,1.54-2c0.47-0.32,0.99-0.48,1.55-0.48      c0.81,0,1.64,0.26,2.48,0.78l-0.83,2.24c-0.59-0.35-1.18-0.52-1.77-0.52c-0.53,0-1,0.16-1.42,0.48      c-0.42,0.32-0.72,0.76-0.9,1.32c-0.27,0.86-0.4,1.8-0.4,2.82v7.46H358.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M367.16,89.18V74.92h2.17v2.16c0.55-1.01,1.07-1.68,1.54-2c0.47-0.32,0.99-0.48,1.55-0.48      c0.81,0,1.64,0.26,2.48,0.78l-0.83,2.24c-0.59-0.35-1.18-0.52-1.77-0.52c-0.53,0-1,0.16-1.42,0.48      c-0.42,0.32-0.72,0.76-0.9,1.32c-0.27,0.86-0.4,1.8-0.4,2.82v7.46H367.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M375.45,82.05c0-2.64,0.73-4.59,2.2-5.87c1.23-1.06,2.72-1.58,4.48-1.58      c1.96,0,3.56,0.64,4.81,1.93c1.24,1.28,1.87,3.06,1.87,5.32c0,1.83-0.28,3.28-0.83,4.33c-0.55,1.05-1.35,1.87-2.4,2.45      c-1.05,0.58-2.2,0.87-3.44,0.87c-2,0-3.61-0.64-4.84-1.92C376.06,86.3,375.45,84.46,375.45,82.05z M377.93,82.05      c0,1.83,0.4,3.19,1.19,4.1c0.8,0.91,1.8,1.36,3.01,1.36c1.2,0,2.2-0.46,2.99-1.37s1.19-2.3,1.19-4.17c0-1.76-0.4-3.1-1.2-4.01      c-0.8-0.91-1.8-1.36-2.99-1.36c-1.21,0-2.21,0.45-3.01,1.36C378.33,78.86,377.93,80.22,377.93,82.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M391.61,89.18V74.92h2.17v2.16c0.55-1.01,1.07-1.68,1.54-2c0.47-0.32,0.99-0.48,1.55-0.48      c0.81,0,1.64,0.26,2.48,0.78l-0.83,2.24c-0.59-0.35-1.18-0.52-1.77-0.52c-0.53,0-1,0.16-1.42,0.48      c-0.42,0.32-0.72,0.76-0.9,1.32c-0.27,0.86-0.4,1.8-0.4,2.82v7.46H391.61z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErr500);
export default __webpack_public_path__ + "static/media/err500.9f6780c6e51dee8f6cc4891c7389ff42.svg";
export { ForwardRef as ReactComponent };